module.exports = "<footer class=\"footer hidden-print\">\n    <div class=\"container\">\n        <p>\n            <small>\n                <a [attr.href]=\"STATIC_URL_MEDPRO_ASSISTANT\" target=\"_blank\">MedProAssistant, LLC</a> | \n                <a [attr.href]=\"STATIC_URL_CONTACT_US\" target=\"_blank\">Contact Us</a> |\n                <a [attr.href]=\"STATIC_URL_ABOUT_US\" target=\"_blank\">About Us</a> | \n                <a href=\"mailto:info@medproassistant.com\">info@medproassistant.com</a>\n            </small>\n        </p>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = 1474
// module chunks = 0